module.exports = __webpack_public_path__ + "img/外框2.21b9c497.png";